import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 md:mb-7">
      <div className="flex items-center gap-3">
        {icon ? (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className={`${icon} text-lg`}></i>
          </span>
        ) : null}
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle ? (
            <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="group inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </Link>
      ) : null}
    </div>
  );
}